var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { STACK_DIRECTION, STACK_GAP, StackView } from "../StackView";
import { createUIElement, SPACING_M } from "../helpers";
var Content = styled(StackView)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    max-height: 100%;\n    overflow-y: auto;\n    padding-bottom: ", ";\n"], ["\n    max-height: 100%;\n    overflow-y: auto;\n    padding-bottom: ", ";\n"])), SPACING_M);
var Wrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    height: 100%;\n    background-color: ", ";\n\n    ", "\n"], ["\n    height: 100%;\n    background-color: ", ";\n\n    ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colorBackgroundNeutralLight;
}, function (_a) {
    var width = _a.width;
    return width && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n            width: ", ";\n        "], ["\n            width: ", ";\n        "])), width);
});
export var SideFilterLayout = createUIElement('SideFilterLayout', function (_a, ref) {
    var className = _a.className, header = _a.header, body = _a.body, width = _a.width, onClick = _a.onClick, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "header", "body", "width", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    return (React.createElement(Wrapper, __assign({}, rest, { className: className, width: width, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }),
        React.createElement(Content, { direction: STACK_DIRECTION.column, gap: STACK_GAP.m },
            header,
            body)));
});
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=SideFilterLayout.js.map